import classNames from 'classnames';

import { useFormikContext } from 'formik';
import * as React from 'react';
import { useMemo } from 'react';

import { Background, backgrounds } from 'shared/constants/backgrounds';
import { useDropZoneInit } from '../../hooks/use-drop-zone-init';
import { Dropzone } from '../../subcomponents/dropzone';
import { Format } from '../../subcomponents/format';
import { FormDropZoneVariantProps } from '../../types';
import { Container } from '../styles';
import BackgroundLogo from './background-logo';

interface Props extends FormDropZoneVariantProps {
  backgroundsList?: Background[];
}

export const CoverDropzone: React.FC<Props> = (props) => {
  const { className, multiple = false, backgroundsList, ...otherProps } = props;
  const { setFieldValue, values } = useFormikContext<{ [key: string]: any[] }>();
  const value = useMemo(() => {
    return (values[otherProps.name][0] ?? {}) as { img?: File | string; background?: Background };
  }, [otherProps.name, values]);

  const { images, ...rest } = useDropZoneInit<{ img?: File | string; background?: Background }>({
    ...otherProps,
    multiple,
    onDrop: (acceptedFiles) => {
      setFieldValue(otherProps.name, [{ ...value, img: acceptedFiles[0] }]);
    },
  });

  const onChangeBackground = (background: Background) => {
    setFieldValue(otherProps.name, [{ ...value, background }]);
  };

  const image = useMemo(() => {
    if (value.img instanceof File) {
      return URL.createObjectURL(value.img);
    }
    return value.img;
  }, [value]);

  return (
    <Container className={className}>
      <Dropzone {...rest} className={classNames('mb-2', { disabled: props.disabled })} />
      <div className="flex w-full">
        <Format />
      </div>
      {image && (
        <div className="mt-7 flex w-full" style={{ position: 'relative' }}>
          <BackgroundLogo
            img={image}
            background={value.background ?? backgroundsList?.[0] ?? backgrounds[0]}
            backgroundsList={backgroundsList ?? backgrounds}
            onChangeBackground={onChangeBackground}
          />
        </div>
      )}
    </Container>
  );
};
